import { api } from './api';

const fiscalService = {
  // Config Fiscal
  getConfig: () => api.get('/api/fiscal/config'),
  getConfigStatus: () => api.get('/api/fiscal/config/status'),
  createConfig: (data) => api.post('/api/fiscal/config', data),
  updateConfig: (id, data) => api.put(`/api/fiscal/config/${id}`, data),

  // Faturas Elegíveis
  getFaturasElegiveis: (params) => api.get('/api/fiscal/faturas-elegiveis', { params }),
  getTomador: (idFatura) => api.get(`/api/fiscal/tomador/${idFatura}`),
  preValidar: (idFatura) => api.post('/api/fiscal/pre-validar', { id_fatura: idFatura }),

  // RPS
  gerarRps: (data) => api.post('/api/fiscal/rps', data),
  gerarRpsLote: (data) => api.post('/api/fiscal/rps/gerar-lote', data),
  listarRps: (params) => api.get('/api/fiscal/rps', { params }),
  obterRps: (id) => api.get(`/api/fiscal/rps/${id}`),
  cancelarRps: (id, motivo) => api.delete(`/api/fiscal/rps/${id}`, { data: { motivo } }),

  // Notas emitidas
  listarNotas: (params) => api.get('/api/fiscal/notas', { params }),

  // Credencial / Certificado
  getCredencial: () => api.get('/api/fiscal/config/credencial'),
  uploadCertificado: (formData) =>
    api.post('/api/fiscal/config/certificado', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  // Emissão unitária
  emitirRps: (id) => api.post(`/api/fiscal/rps/${id}/emitir`),

  // Reenvio controlado (RPS rejeitado definitivamente pela Prefeitura)
  reenviarRps: (id) => api.post(`/api/fiscal/rps/${id}/reenviar`),
};

export default fiscalService;
